"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useDescriptions = _interopRequireDefault(require("../../../ProductDetail/hooks/useDescriptions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Description = _ref => {
  let {
    lang = "de",
    type = "short"
  } = _ref;
  const descriptions = (0, _useDescriptions.default)({
    lang,
    type
  });
  const {
    description
  } = descriptions || {};
  if ((0, _isEmpty.default)(descriptions)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-product-detail-description"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-shop-product-detail-description__text",
    component: "div",
    dangerouslySetInnerHTML: {
      __html: description
    },
    variant: "body2"
  }));
};
Description.propTypes = {
  lang: _propTypes.default.string,
  type: _propTypes.default.string
};
var _default = exports.default = Description;